import { SvgProps } from "../../types";

const CopyRight = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill={props.fill ? props.fill : "#4C5269"}
      d="M5.3 9.275h2.65a.641.641 0 0 0 .472-.19.641.641 0 0 0 .19-.473V7.288H7.288v.663H5.963V5.3h1.324v.663h1.326V4.638a.641.641 0 0 0-.191-.473.641.641 0 0 0-.472-.19H5.3a.641.641 0 0 0-.472.19.641.641 0 0 0-.19.473v3.975c0 .187.063.345.19.472s.284.19.472.19Zm1.325 3.975a6.451 6.451 0 0 1-2.584-.522 6.691 6.691 0 0 1-2.103-1.416A6.69 6.69 0 0 1 .522 9.21 6.451 6.451 0 0 1 0 6.625c0-.916.174-1.778.522-2.584a6.69 6.69 0 0 1 1.416-2.103A6.69 6.69 0 0 1 4.04.522 6.451 6.451 0 0 1 6.625 0c.916 0 1.778.174 2.584.522a6.69 6.69 0 0 1 2.103 1.416 6.691 6.691 0 0 1 1.416 2.103c.348.806.522 1.668.522 2.584 0 .916-.174 1.778-.522 2.584a6.691 6.691 0 0 1-1.416 2.103 6.691 6.691 0 0 1-2.103 1.416 6.451 6.451 0 0 1-2.584.522Zm0-1.325c1.48 0 2.733-.513 3.76-1.54 1.027-1.027 1.54-2.28 1.54-3.76s-.513-2.733-1.54-3.76c-1.027-1.027-2.28-1.54-3.76-1.54s-2.733.513-3.76 1.54c-1.027 1.027-1.54 2.28-1.54 3.76s.513 2.733 1.54 3.76c1.027 1.027 2.28 1.54 3.76 1.54Z"
    />
  </svg>
);
export default CopyRight;
